import React, {useMemo} from "react";
import PageHeader from "@components/Page/PageHeader";
import PageSection from "@components/Page/PageSection";
import ResponsivePicture from "@components/ResponsivePicture/ResponsivePicture";
import InvoiceBanner from "@assets/images/invoice/invoice-card.png";
import "./InvoicePage.scss";
import PreFooter from "@components/Prefooter/PreFooter";
import InvoiceForm from "@pages/Invoice/Components/InvoiceForm/InvoiceForm";
import {findFirstSection, getCmsPage} from "@lib/Cms/CmsUtils";
import {SECTION_TYPE} from "@lib/Cms/CmsModels";
import CatalogPreview from "@components/Catalog/CatalogPreview/CatalogPreview";
import Page from "@components/Page/Page";
import PageContent from "@components/Page/PageContent";
import {UploadIcon} from "@components/Icons/UploadIcon";
import {useEvents} from "@lib/Event/EventHooks";
import {EventFilters, EventTypeEnum} from "@lib/Event/EventModels";

const INVOICE_EVENT_FILTERS: EventFilters = {
    type: EventTypeEnum.PDA
}

export default function InvoicePage() {

    const {data: events} = useEvents(INVOICE_EVENT_FILTERS);
    const pdaEvent = events && events.length > 0 ? events[0] : null;

    const {sections: homeSections} = useMemo(() => getCmsPage("homepage") ?? {}, []);

    const invoicePageSection = findFirstSection(homeSections, SECTION_TYPE.INVOICE_PAGE);

    const formSection = useMemo(() => findFirstSection(invoicePageSection?.sections, SECTION_TYPE.INVOICE_FORM, true), [invoicePageSection]);
    const catalogSection = useMemo(() => findFirstSection(invoicePageSection?.sections, SECTION_TYPE.CATALOG_PREVIEW), [invoicePageSection]);
    const preFooterSection = useMemo(() => findFirstSection(invoicePageSection?.sections, SECTION_TYPE.PRE_FOOTER), [invoicePageSection]);

    return (
        <>
            <Page>

                <PageHeader cms={invoicePageSection}/>

                <PageContent>

                    <PageSection bg={formSection?.options?.bgType}>
                        <div className="page-section__content">

                            <div className="invoice-card">

                                <div className="invoice-card__left">
                                    <header className="form__header">
                                        <div className="form__icon">
                                            <span className="icon"><UploadIcon color={"#db3700"}/></span>
                                            {!!formSection?.subTitle &&
                                                <span
                                                    className={"tp-xs semibold color-primary"}>{formSection.subTitle}</span>
                                            }
                                        </div>
                                        {!!formSection?.title &&
                                            <h3 className="form__title tp-xl bold">{formSection.title}</h3>
                                        }
                                    </header>
                                    {!!formSection && !!pdaEvent && <InvoiceForm cms={formSection} event={pdaEvent}/>}
                                </div>

                                <div className="invoice-card__right">
                                    <ResponsivePicture
                                        images={[InvoiceBanner]}
                                    />
                                </div>

                            </div>

                            {!!formSection?.text &&
                                <div className="invoice-hint tp-m light"
                                     dangerouslySetInnerHTML={{__html: formSection.text}}/>
                            }

                        </div>
                    </PageSection>

                    {!!catalogSection && <CatalogPreview cms={catalogSection}/>}

                </PageContent>

            </Page>

            {!!preFooterSection && <PreFooter cms={preFooterSection}/>}

        </>
    );
}
